import { GsCtaAnswerFrag } from '@/graphql/fragments/GsCtaAnswerFrag';
import { buildItemQuery } from '@/graphql/index';
import { GsCtaServiceFrag } from '@/graphql/fragments/GsCtaServiceFrag';
import { GsCtaQuestionFrag } from '@/graphql/fragments/GsCtaQuestionFrag';

export const getGsCtaAnswerQuery = (id: string, lang = 'en-US') =>
  buildItemQuery(id, lang, 'GsCtaAnswerFrag', GsCtaAnswerFrag);

export const getGsCtaServiceQuery = (id: string, lang = 'en-US') =>
  buildItemQuery(id, lang, 'GsCtaServiceFrag', GsCtaServiceFrag);
export const getGsCtaQuestionQuery = (id: string, lang = 'en-US') =>
  buildItemQuery(id, lang, 'GsCtaQuestionFrag', GsCtaQuestionFrag);
